import React from 'react';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import PlannerTooltip from '../planner-tooltip/planner-tooltip';
import UndoButton from '../../components/undo-button/undo-button';
import useStore from '../../stores/helpers/use-context';
import { UpdatingSource } from '../types';

import './map-actions.scss';

interface Props {
	changeTasksSelection: (tasksIds: number[], source: UpdatingSource) => void;
}
const MapActions = ({ changeTasksSelection }: Props) => {
	const {
		undoLastChange,
		isThereUserChange,
		optimizationRequestId,
		translations: { actionsTranslations },
		isReadOnly
	} = useStore();

	return (
		<div className="map-actions">
			{!isReadOnly && (
				<UndoButton
					onUndoLastChange={() => {
						undoLastChange();
						changeTasksSelection([], UpdatingSource.PlannerMap);
					}}
					isThereChange={isThereUserChange}
					translation={{ undoLastChange: actionsTranslations.undoLastChange }}
				/>
			)}
			{optimizationRequestId && (
				<CopyToClipboard text={optimizationRequestId}>
					<div className="uuid-copy-area" data-tip={actionsTranslations.copy}>
						<div className="uuid-copy-text">
							<span className="uuid-header">{actionsTranslations.optimizationUuid}: </span>
							{optimizationRequestId}
						</div>
						<BringgIcon iconName={BringgFontIcons.Copy} />
					</div>
				</CopyToClipboard>
			)}
			<PlannerTooltip />
		</div>
	);
};

export default MapActions;
